export default [
  {
    name: "getEmptyTimes",
    path: "user/presession/get-empty-time",
    method: "get",
    loading: true,
    alert: true,
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: "reserveTime",
    path: "user/presession/reserve-time",
    method: "post",
    loading: true,
    alert: true,
    defaultHeader: {},
    defaultBody: {},
  },

  {
    name: "setSession",
    path: "user/presession/set-session",
    method: "post",
    loading: true,
    alert: true,
    defaultHeader: {},
    defaultBody: {},
  },
];
